import { conflictingMobilePageMapping } from '../../context/page-mapping';
import { t } from './translations';

const isMobileOrTablet = () => {
  const userAgent = navigator?.userAgent?.toLowerCase() ?? '';
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);
  const isTablet =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent,
    );
  return isMobile || isTablet;
};
const isMobile = () => {
  const isMob = /iPhone|Android/i.test(navigator.userAgent);
  return isMob;
};
const isMobilePageConflicting = () => {
  const pageUrl = window.location.href;
  return !!Object.keys(conflictingMobilePageMapping).find((ele) => pageUrl.includes(t(ele)));
};

const isSafari = () => {
  const { userAgent } = navigator;
  return userAgent.includes('Safari') && !userAgent.includes('Chrome');
};

export { isMobileOrTablet, isMobile, isMobilePageConflicting, isSafari };
